export default __webpack_public_path__ + "static/media/padideh81.d54f37f9.png";